import { RootMutationTypes } from './types'

const mutations = {
  [RootMutationTypes.SetDeleteFilterStatus](state, { status }) {
    return state.delete_filter_status = status
  }
}

export { mutations }
